import { BarContent, GraphValueText } from "../Graph/Graph";
import { Box, useTheme } from "arkh";
import React, { useMemo } from "react";

export function NumberBarC(props: {
  isActive: boolean;
  totalHeight: number;
  maxVal?: number | null;
  val?: number | null;
  formatedVal?: string | null;
  parts?: { weight: number; color?: string }[];
}) {
  const heightOfBar = useMemo(() => {
    if (props.maxVal === null || props.maxVal === undefined) {
      return 0;
    }
    if (props.val === null || props.val === undefined) {
      return 0;
    }
    const ret = Math.max(1, (props.val / props.maxVal) * props.totalHeight);
    if (Number.isNaN(ret)) {
      return 0;
    }
    return ret;
  }, [props.maxVal, props.val, props.totalHeight]);

  const theme = useTheme();
  const parts = useMemo(
    () =>
      props.parts
        ? props.parts.map((p) => ({
            weight: p.weight,
            color:
              p.color ?? (props.isActive ? theme.darkerText : theme.washedText),
          }))
        : [
            {
              weight: 1,
              color: props.isActive ? theme.darkerText : theme.washedText,
            },
          ],
    [props.isActive, props.parts, theme.darkerText, theme.washedText]
  );
  return (
    <Box
      style={{
        width: "100%",
        flex: 1,
        justifyContent: "flex-end",
        alignContent: "center",
      }}
    >
      <GraphValueText emphasis={props.isActive}>
        {props.formatedVal ?? ""}
      </GraphValueText>
      <BarContent parts={parts} height={heightOfBar} />
    </Box>
  );
}

export const NumberBar = React.memo(NumberBarC);
